import { ChainId, ChainLayer, ChainNetwork, isChainIdCronosEvm, isChainIdL2, } from '../types';
import { NeverError } from './NeverError';
export const getLayerOfChain = (chainId) => {
    if (isChainIdL2(chainId)) {
        return ChainLayer.L2;
    }
    if (isChainIdCronosEvm(chainId)) {
        return ChainLayer.CronosEvm;
    }
    throw NeverError(chainId);
};
export const getChainOfLayer = (layer, chainNetwork) => {
    switch (layer) {
        case ChainLayer.L2:
            return chainNetwork === ChainNetwork.mainnet
                ? ChainId.CRONOS_ZK_MAINNET
                : ChainId.CRONOS_ZK_TESTNET;
        case ChainLayer.CronosEvm:
            return chainNetwork === ChainNetwork.mainnet
                ? ChainId.CRONOS_EVM_MAINNET
                : ChainId.CRONOS_EVM_TESTNET;
    }
};
export const getNetworkOfChain = (chainId) => {
    if (chainId === ChainId.CRONOS_ZK_MAINNET ||
        chainId === ChainId.CRONOS_EVM_MAINNET) {
        return ChainNetwork.mainnet;
    }
    if (chainId === ChainId.CRONOS_ZK_TESTNET ||
        chainId === ChainId.CRONOS_EVM_TESTNET) {
        return ChainNetwork.testnet;
    }
    throw NeverError(chainId);
};
